function TriangleDownArrow() {
  return (
    <svg className="mr-[3px] w-4 h-4" viewBox="0 0 16 16">
      <path d="M8,12,5,6h6Z" />
    </svg>
  );
}

export default TriangleDownArrow;
